import { USER_URL } from "api/routes";
import { profileInstance } from "hooks/useRequest/helper";
import tokenService from "services/token.service";



export const getUser = async ({ id }) => {
    return await profileInstance.get(USER_URL + "/" + id, {
        headers: {
            authorization: `Token ${tokenService.getLocalAccessToken()}`
        }
    })
        .then(res => res.data);
};